import { useState } from "react";
import { FunctionalComponent, h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import { Divider, Button, Upload } from "antd";
import qurrystring from "query-string";
import moment from "moment";
import { ExpandOutlined } from "@ant-design/icons";
import Container from "../../components/container";
import BaseForm from "../../components/form";
import { useForm } from "react-hook-form";
import { FORM_SEARCH } from "./constants/forms";
import { Text, TextHeader } from "../../components/text";
import { PrimaryButton } from "../../components/button/primary";
import { SecondaryButton } from "../../components/button/secondary";
import { PreviewUpload } from "./view/modal/preview";
import { COULMN_DATA, COULMN_PREVIEW } from "./constants/columns";
import { UploadChangeParam } from "antd/lib/upload";
import {
  ButtonUploadFileExcel,
  ContainerDataDevice,
  ContainerDevice,
  ContainerImportDevice,
  ContainerSearch,
  DivButtonExportFile,
  DivButtonImportDevice,
  DivButtonPreview,
  DivNoPreview,
  DivTableData,
  HeaderButtonImportDevice,
} from "./styled";
import { PrimaryButtonClosed } from "../../components/button/buttonClosed";
import { ModalEditData } from "./view/modal/edit";
import { TablePreview } from "./view/table/preview";
import { TableData } from "./view/table/data";
import { IModalRef } from "./interfaces/modal";
import { IStateChangeDevice } from "./interfaces/state";
import { useGetOptions } from "./hook/useGetOptions";
import { useGetDevice } from "./hook/useGetDevice";
import { useFileExcell } from "./hook/useFileExcel";
import WrapperComponent from "../../components/hoc/WrapperComponent";
import { ButtonCSV } from "../../components/button/buttonCSV";
import { HEADERS } from "./constants/exportexcel";

const ManageDeviceScene: FunctionalComponent = () => {
  let modalRefEditData = useRef<IModalRef>();
  let modalRefPreview = useRef<IModalRef>();
  const [forceLoading, setForceLoading] = useState(false);
  const [forceLoadingSearch, setForceLoadingSearch] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const { control, setValue, getValues, reset } = useForm({});
  const { onSearch, getDevice, devices, setDevice } = useGetDevice();
  const { getImportDeviceStatusOption, options } = useGetOptions();
  const {
    stateUpload,
    stateUploadError,
    onUploadFileExcel,
    onSaveUploadFileExcel,
    dowloadExmapleImportedDevice,
    loadingPreviewError,
    fileUpload,
    setFileUpload,
    setStateUpload,
    importErrMsg,
  } = useFileExcell();

  useEffect(() => {
    getImportDeviceStatusOption();
  }, []);

  useEffect(() => {
    const firstGetDevice = async () => {
      try {
        setLoading(true);
        await getDevice();
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    firstGetDevice();
  }, []);

  useEffect(() => {
    if (stateUpload.length < 1 || stateUploadError.length > 0) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [stateUpload, stateUploadError]);

  const props = {
    beforeUpload: () => false,
    onChange: (file: UploadChangeParam) => onUploadFileExcel(file),
    fileList: fileUpload,
  };

  const onSubmitSearch = async () => {
    const {
      search_id: deviceId,
      search_pl: lotId,
      search_status_device: status,
    } = getValues();
    const params = {
      deviceId,
      lotId,
      status,
    };
    const queryString = qurrystring.stringify(params);
    setForceLoadingSearch(true);
    setLoading(true);
    window.history.replaceState(null, "", `?${queryString}`);
    await onSearch(queryString);
    setLoading(false);
    setForceLoadingSearch(false);
  };

  const onSubmitClearSearch = async (force?: boolean) => {
    reset();
    const deviceId = getValues().search_id;
    const lotId = getValues().search_pl;
    const status = getValues().search_status_device;
    const params = {
      deviceId: deviceId,
      lotId: lotId,
      status: status,
    };
    const queryString = qurrystring.stringify(params);
    force && setForceLoading(true);
    setLoading(true);
    window.history.replaceState(null, "", `?${queryString}`);
    await getDevice();
    setLoading(false);
    force && setForceLoading(false);
  };

  const onPressDowloadExampleExcel = async (force?: boolean) => {
    force && setForceLoading(true);
    await dowloadExmapleImportedDevice();
    force && setForceLoading(false);
  };

  const onPressSaveExcel = async (item: any) => {
    try {
      setConfirmLoading(true);
      await onSaveUploadFileExcel(item);
    } catch (error) {
      console.log(error);
    } finally {
      setConfirmLoading(false);
    }
  };

  function onCallBackModalEdit(item: any) {
    const {
      bluetooth,
      deviceStatusId,
      proxy,
      remark,
      customerCode,
      isAvailable,
      lotMonth,
    } = item;
    const findIndex = devices.findIndex((e) => e.deviceID === item.deviceID);
    if (findIndex === -1) {
      return;
    }
    const stateDevice = JSON.parse(JSON.stringify(devices));
    stateDevice[findIndex].remark = remark;
    stateDevice[findIndex].deviceStatusId = deviceStatusId;
    stateDevice[findIndex].bluetooth = bluetooth;
    stateDevice[findIndex].proxy = proxy;
    stateDevice[findIndex].customerCode = customerCode;
    stateDevice[findIndex].isAvailable = isAvailable;
    stateDevice[findIndex].lotMonth = lotMonth
      ? moment(lotMonth).format("YYYY/MM")
      : stateDevice[findIndex].lotMonth;
    setDevice(stateDevice);
  }

  function onCallBackModalUpload(item: any) {
    setFileUpload(item);
    setStateUpload(item);
  }

  return (
    <Container>
      <ContainerDevice>
        <ContainerDataDevice>
          <TextHeader text={"ข้อมูลเครื่องตัด"} divider={true} />
          <BaseForm
            control={control}
            forms={FORM_SEARCH({ options, onSubmitSearch })}
            setValue={setValue}
            getValues={getValues}
          />
          <ContainerSearch>
            <PrimaryButton
              label={"ค้นหา"}
              style={{ marginLeft: "10px" }}
              mobileStyle={{ marginTop: "10px" }}
              tabletStyle={{ marginTop: "10px" }}
              isLoading={forceLoadingSearch}
              forceLoading={forceLoadingSearch}
              onPress={onSubmitSearch}
            />
            <SecondaryButton
              label={"ล้างข้อมูล"}
              style={{ marginLeft: "10px" }}
              mobileStyle={{ marginTop: "10px" }}
              tabletStyle={{ marginTop: "10px" }}
              isLoading={true}
              forceLoading={forceLoading}
              onPress={onSubmitClearSearch}
            />
          </ContainerSearch>
        </ContainerDataDevice>
        <Divider type="vertical" style={{ height: "320px" }} />
        <ContainerImportDevice>
          <HeaderButtonImportDevice>
            <TextHeader text={"นำเข้าเครื่องตัด"} divider={false} />
            <DivButtonImportDevice>
              <Upload
                {...props}
                maxCount={1}
                accept=".xlsx, .csv, application/vnd.ms-excel"
              >
                <ButtonUploadFileExcel>อัปโหลด</ButtonUploadFileExcel>
              </Upload>
              <SecondaryButton
                label={"ดาวน์โหลด template"}
                style={{ marginLeft: "10px" }}
                mobileStyle={{ marginTop: "20px" }}
                tabletStyle={{ marginTop: "20px" }}
                isLoading={loading}
                forceLoading={forceLoading}
                onPress={onPressDowloadExampleExcel}
              />
            </DivButtonImportDevice>
            <PrimaryButtonClosed
              label={"บันทึก"}
              style={{ marginLeft: "10px" }}
              mobileStyle={{ marginTop: "20px" }}
              tabletStyle={{ marginTop: "20px" }}
              isDisabled={isDisabled}
              isLoading={loading}
              forceLoading={confirmLoading}
              onPress={() => onPressSaveExcel(stateUpload)}
            />
          </HeaderButtonImportDevice>
          <Divider style={{ marginTop: 5, marginBottom: 0 }} />
          <Text text={importErrMsg} color="red" />
          <DivButtonPreview>
            {stateUpload.length > 0 ? (
              <Button
                icon={(<ExpandOutlined size={14} />) as React.ReactNode}
                type="link"
                onClick={(e: any) =>
                  modalRefPreview.current &&
                  modalRefPreview.current.openModal(e)
                }
              >
                ดูตัวอย่าง
              </Button>
            ) : (
              <DivNoPreview></DivNoPreview>
            )}
          </DivButtonPreview>
          <TablePreview
            columns={COULMN_PREVIEW()}
            data={stateUploadError}
            loading={loadingPreviewError}
          />
        </ContainerImportDevice>
      </ContainerDevice>
      <DivTableData>
        <DivButtonExportFile>
          <ButtonCSV
            label={"Export"}
            data={devices}
            header={HEADERS}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ margin: "5px" }}
            tabletStyle={{ margin: "5px" }}
            fileName={"DeviceHeader.csv"}
          />
        </DivButtonExportFile>
        <TableData
          columns={COULMN_DATA({
            onEdit: (e: IStateChangeDevice) =>
              modalRefEditData.current && modalRefEditData.current.openModal(e),
          })}
          data={devices}
          loading={loading}
        />
      </DivTableData>
      <PreviewUpload
        ref={modalRefPreview}
        data={stateUpload}
        isDisabled={isDisabled}
        onCallBackModalUpload={(e: IStateChangeDevice) =>
          onCallBackModalUpload(e)
        }
      />
      <ModalEditData
        ref={modalRefEditData}
        onCallBackModalEdit={(e: IStateChangeDevice) => onCallBackModalEdit(e)}
        options={options}
      />
    </Container>
  );
};

export default WrapperComponent("ManageDeviceScene")(ManageDeviceScene);
